import { render } from "./hotKey.vue?vue&type=template&id=3a888bff"
import script from "./hotKey.vue?vue&type=script&lang=js"
export * from "./hotKey.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__